// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"0ae29022","787":"be509526","815":"4384012d"}[chunkId] + ".chunk.js";
};